import React, { useImperativeHandle, useRef } from "react";
import styled from "styled-components";
import { Link } from "gatsby";
import { device } from "@helpers";
import "@scss/mystyles.scss";
import Icon from "@components/Icon";

const HEIGHT_NAV_ITEM = 58;

const StyleContainer = styled.div`
  max-width: 2560px;
  display: ${props => props.display};
  margin-right: 0;

  margin: auto;
  min-height: 715px;

  @media (min-width: ${device.tablet}) and (max-width: ${device.desktop}) {
    min-height: ${props => {
      let minHeight;
      return `${minHeight}px`;
    }};
  }

  @media (max-width: ${device.mobileXL}) {
    min-height: ${props => {
      const minHeight =
        props.content &&
        props.content.containerHeight &&
        props.content.containerHeight + 715;
      return props.content.containerHeight ? `${minHeight}px` : "715px";
    }};
  }
`;

const StyleContainerMenu = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  min-height: inherit;

  .menu {
    top: -10px;
    left: 0;
    height: 500px;
    padding-left: 48px;
    background-color: #ffaa98;
    border-radius: 60px 0px 0px 0px;
    box-shadow: -5px 0 30px -5px rgba(18, 18, 82, 0.2);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: inherit;
    display: none;

    opacity: 0;
    transition: opacity 0.3s ease 0s;
    cursor: pointer;

    &.open {
      display: block;
      opacity: 1;
      animation-name: slide;
      animation-duration: 0.5s;
      transition: all 0.23s ease 0s;
      width: 50%;

      @media (min-width: ${device.laptop}) and (max-width: ${device.desktop}) {
        @keyframes slide {
          0% {
            opacity: 0;
            width: 0%;
          }
          50% {
            opacity: 0;
          }
          100% {
            width: 50%;
            opacity: 1;
          }
        }
      }

      @media (max-width: ${device.mobileXL}) {
        width: 100%;
        opacity: 1;
        animation-name: slide;
        animation-duration: 0.5s;
        transition: all 0.23s ease 0s;

        @keyframes slide {
          0% {
            opacity: 0;
            width: 0%;
          }
          50% {
            opacity: 0;
          }
          100% {
            width: 100%;
            opacity: 1;
          }
        }
      }
    }

    :focus {
      outline: 0;
      box-shadow: none !important;
    }

    &.close {
      animation-name: slide1;
      animation-duration: 2000ms;
      transition: all 0ms ease-in-out 0s;
      opacity: 0;
      height: 0;
      width: 0%;

      z-index: 5;

      @media (min-width: ${device.tablet}) and (max-width: ${device.desktop}) {
        margin-top: 0px;
        @keyframes slide1 {
          0% {
            opacity: 1;
            width: 50%;
            margin-top: -85px;
          }
          50% {
            opacity: 0.5;
            margin-top: -85px;
          }
          100% {
            width: 0%;
            opacity: 0;
            height: 0;
            margin-top: -85px;
          }
        }
      }

      @media (max-width: ${device.mobileXL}) {
        margin-top: 0px;
        width: 100%;
        opacity: 0;
        animation-name: slide-close;
        animation-duration: 0.25s;
        transition: all 0.25s ease-out 0s;

        @keyframes slide-close {
          0% {
            opacity: 1;
            width: 100%;
            margin-top: -50px;
          }
          50% {
            opacity: 0.5;
            margin-top: -50px;
          }
          100% {
            width: 0%;
            opacity: 0;
            margin-top: -50px;
          }
        }
      }
    }

    &.default {
      opacity: 0;
      width: 0%;
      display: none;
    }

    a {
      pointer-events: all;
    }
  }
`;

const StyleMenu = styled.div``;

const StyleCloseIconWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: flex-end;
  padding-right: 35.9px;
  padding-top: 15px;

  @media (max-width: ${device.mobileXL}) {
    padding-right: 27px;
  }
`;

const StyleIconsContainer = styled.div`
  font-size: 18px !important;
  padding-left: 5px;

  & > div.icon-close-felix {
    font-family: icons !important;
    line-height: 1em;
    font-size: 30px !important;

    @media (max-width: ${device.mobileXL}) {
      font-size: 40px !important;
    }
  }
`;

const StyleLinkWrapper = styled.div`
  font-size: 30px !important;
  font-weight: 600;
  color: #121252;
  padding-top: 32px;
`;

const StyleInnerLinkWrapper = styled.div`
  font-size: 22px !important;
  color: #121252;
  padding-bottom: 10px;
  padding-top: 5px;

  &:empty {
    padding-bottom: 0px;
    padding-top: 0px;
  }
`;

const StyleMenuWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
`;

const StyleInnerCategories = styled.div`
  display: ${props => props.display};
  flex-direction: column;
`;

const MenuLink = styled(Link)`
  text-decoration: none;
`;

const closeIconSizes = {
  iconMobile: 30,
  iconTablet: 40,
  iconLaptop: 60,
  iconDesktop: 60,
  iconDesktopLarge: 60,
};

const menuIconSizes = {
  iconMobile: 30,
  iconTablet: 30,
  iconLaptop: 30,
  iconDesktop: 30,
  iconDesktopLarge: 30,
};

class Menu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: "",
      containerHeight: 0,
      categorySelected: "",
    };
  }

  getClassName = () => {
    if (this.state.open === "") return `menu default`;
    return this.state.open ? `menu open` : `menu close`;
  };

  render() {
    const { onClose, data } = this.props;
    const navigationList = data && data.navigation;
    const navigation =
      Array.isArray(navigationList) &&
      navigationList.sort((a, b) => (a.order < b.order ? -1 : 1));

    const renderMenuItem = item => {
      const wrapMenuLabel = (label, isSubmenu) => {
        return isSubmenu ? (
          <StyleInnerLinkWrapper>{label}</StyleInnerLinkWrapper>
        ) : (
          <StyleLinkWrapper>{label}</StyleLinkWrapper>
        );
      };

      const renderMenu = (item, isSubmenu) => {
        if (item && item.link) {
          return (
            <MenuLink to={item.link}>
              {wrapMenuLabel(item.name, isSubmenu)}
            </MenuLink>
          );
        }
        return (
          <MenuLink to={item.link}>
            {wrapMenuLabel(item.name, isSubmenu)}
          </MenuLink>
        );
      };

      const renderSubmenu = (items, category) => {
        return (
          <>
            <StyleMenuWrapper>{renderMenu(items, true)}</StyleMenuWrapper>
            <StyleInnerCategories
              display={
                this.state.categorySelected === category ? "flex" : "none"
              }
            >
              {items &&
                Array.isArray(items) &&
                items.map((item, index) => renderMenu(item, true))}
            </StyleInnerCategories>
          </>
        );
      };

      return (
        <>
          <StyleMenuWrapper>
            {renderMenu(item, false)}
            {item.subNav && (
              <StyleIconsContainer>
                <Icon
                  iconName={
                    this.state.categorySelected === item.name
                      ? "subtract"
                      : "add"
                  }
                  onClick={() =>
                    this.state.categorySelected !== item.name
                      ? this.setState({
                          categorySelected: item.name,
                          containerHeight:
                            HEIGHT_NAV_ITEM * 2 + this.state.containerHeight,
                        })
                      : this.setState({
                          categorySelected: "",
                          containerHeight: this.state.containerHeight,
                        })
                  }
                  iconSizes={menuIconSizes}
                />
              </StyleIconsContainer>
            )}
          </StyleMenuWrapper>
          {item.subNav && renderSubmenu(item.subNav, item.name)}
        </>
      );
    };

    return (
      <StyleContainer
        display={this.state.open ? "block" : "none"}
        content={{
          containerHeight: this.state.containerHeight,
        }}
      >
        <StyleContainerMenu>
          <StyleMenu
            role="button"
            tabIndex="0"
            className={this.getClassName()}
            // onClick={onClose}
          >
            <StyleCloseIconWrapper>
              <StyleIconsContainer>
                <Icon
                  iconName="close"
                  onClick={onClose}
                  iconSizes={closeIconSizes}
                />
              </StyleIconsContainer>
            </StyleCloseIconWrapper>
            {this.state.open &&
              navigation.map((item, index) => renderMenuItem(item))}
          </StyleMenu>
        </StyleContainerMenu>
      </StyleContainer>
    );
  }

  close() {
    this.setState({ open: false });
  }

  open() {
    this.setState({ open: true });
  }
}

export default React.forwardRef((props, ref) => {
  const menuRef = useRef();

  useImperativeHandle(ref, () => ({
    open(marginTop) {
      menuRef.current.open();
    },
    close() {
      menuRef.current.close();
    },
  }));

  return <Menu ref={menuRef} {...props} />;
});
